function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "prefix__a",
  x1: "55.746%",
  x2: "42.919%",
  y1: ".982%",
  y2: "88.628%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#E40C61"
}), React.createElement("stop", {
  offset: "14.26%",
  stopColor: "#E63F5B"
}), React.createElement("stop", {
  offset: "33.56%",
  stopColor: "#EA644F"
}), React.createElement("stop", {
  offset: "52.29%",
  stopColor: "#EC7B3C"
}), React.createElement("stop", {
  offset: "70.03%",
  stopColor: "#EE8B28"
}), React.createElement("stop", {
  offset: "86.38%",
  stopColor: "#F09413"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#F09706"
})), React.createElement("linearGradient", {
  id: "prefix__b",
  x1: "72.982%",
  x2: "21.676%",
  y1: ".982%",
  y2: "88.628%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#E40C61"
}), React.createElement("stop", {
  offset: "14.26%",
  stopColor: "#E63F5B"
}), React.createElement("stop", {
  offset: "33.56%",
  stopColor: "#EA644F"
}), React.createElement("stop", {
  offset: "52.29%",
  stopColor: "#EC7B3C"
}), React.createElement("stop", {
  offset: "70.03%",
  stopColor: "#EE8B28"
}), React.createElement("stop", {
  offset: "86.38%",
  stopColor: "#F09413"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#F09706"
})), React.createElement("linearGradient", {
  id: "prefix__c",
  x1: "125.084%",
  x2: "21.411%",
  y1: "47.866%",
  y2: "51.719%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#F09724"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#E81C69"
})), React.createElement("linearGradient", {
  id: "prefix__d",
  x1: "125.084%",
  x2: "21.411%",
  y1: "43.335%",
  y2: "55.372%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#F09724"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#E81C69"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", null, React.createElement("path", {
  fill: "url(#prefix__a)",
  d: "M9.848 27.78v4.997H5.497V27.78m2.175 5.06v4.936"
}), React.createElement("path", {
  fill: "url(#prefix__b)",
  d: "M15.287 10.287v11.245c0 1.657-.573 3.246-1.593 4.418-1.02 1.171-2.404 1.83-3.846 1.83H5.497c-3.004 0-5.439-2.798-5.439-6.248V10.287"
}), React.createElement("path", {
  fill: "url(#prefix__c)",
  fillRule: "nonzero",
  d: "M.37 3.472h8.31c.122 0 .22.098.22.22V5.06c0 .122-.098.22-.22.22H.37c-.122 0-.22-.098-.22-.22V3.692c0-.122.098-.22.22-.22z",
  transform: "rotate(90 4.525 4.376)"
}), React.createElement("path", {
  fill: "url(#prefix__c)",
  fillRule: "nonzero",
  d: "M6.857 3.472h8.31c.123 0 .221.098.221.22V5.06c0 .122-.098.22-.22.22h-8.31c-.123 0-.221-.098-.221-.22V3.692c0-.122.098-.22.22-.22z",
  transform: "rotate(90 11.012 4.376)"
}), React.createElement("path", {
  fill: "url(#prefix__d)",
  fillRule: "nonzero",
  d: "M5.483 34.519h4.51c.122 0 .22.098.22.22v1.367c0 .122-.098.22-.22.22h-4.51c-.122 0-.22-.098-.22-.22v-1.367c0-.122.098-.22.22-.22z",
  transform: "rotate(90 7.738 35.422)"
})), React.createElement("path", {
  fillRule: "nonzero",
  stroke: "#FFF",
  strokeLinecap: "round",
  d: "M14 20c0 2.761-2.239 5-5 5"
}));

var SvgOrangePlug = function SvgOrangePlug(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 38,
    viewBox: "0 0 16 38",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOrangePlug, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/orangePlug.a9d70027.svg";
export { ForwardRef as ReactComponent };